import React, { Fragment, useState, useContext, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  Card,
  ButtonGroup,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

import DashboardContext from "../../../context/dashboard/DashboardContext";

const Shopify = () => {
  const dashboardContext = useContext(DashboardContext);
  const { getDashboardShopify, shopify } = dashboardContext;
  const [loading, setLoading] = useState(false);
  const [daySelected, setDaySelected] = useState("Today");
  const [dayButtonColor, setDayButtonColor] = useState({
    todayBG: "#ffffff",
    todayText: "normal",
    yesterdayBG: "#ffffff",
    yesterdayText: "normal",
  });
  const [totalRecords, setTotalRecords] = useState({
    total_orders: 0,
  });

  useEffect(() => {
    if (daySelected) {
      if (daySelected === "Today") {
        setDayButtonColor({
          todayBG: "#dddddd",
          todayText: "bold",
          yesterdayBG: "#ffffff",
          yesterdayText: "normal",
        });
      } else if (daySelected === "Yesterday") {
        setDayButtonColor({
          todayBG: "#ffffff",
          todayText: "normal",
          yesterdayBG: "#dddddd",
          yesterdayText: "bold",
        });
      }
    }
  }, [daySelected]);

  const useStyles = makeStyles((theme) => ({
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
    bgColor: {
      backgroundColor: theme.palette.primary.dark,
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    var from = "";
    var to = "";
    setLoading(true);
    if (daySelected === "Today") {
      from = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(32, 0, 0, 0)).toISOString();
    } else if (daySelected === "Yesterday") {
      from = new Date(new Date().setHours(-16, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
    }
    getDashboardShopify(from, to);
    //eslint-disable-next-line
  }, [daySelected]);

  useEffect(() => {
    if (shopify) {
      setTotalRecords({
        total_orders: shopify.total_orders,
      });
      setLoading(false);
    }
  }, [shopify]);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        className={classes.bgColor}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          style={{
            height: 100,
          }}
        >
          <Grid item>
            <Typography variant="h6" className={classes.headerText}>
              Shopify{" "}
            </Typography>{" "}
          </Grid>{" "}
          <Grid item>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                height: "90%",
              }}
              spacing={1}
            >
              <Grid item>
                <Typography variant="h6" className={classes.headerText}>
                  <strong> {totalRecords.total_orders} </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid item>
                <Typography variant="h6" className={classes.headerText}>
                  orders{" "}
                </Typography>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            {" "}
            {shopify && loading === false ? (
              <Card
                style={{
                  height: 30,
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    height: "100%",
                  }}
                >
                  <Grid item> </Grid>{" "}
                  <Grid item>
                    <Typography variant="subtitle1">
                      Total Value:{" "}
                      <strong> $ {shopify.total_price.toFixed(2)} </strong>{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                  <Grid item> </Grid>{" "}
                </Grid>{" "}
              </Card>
            ) : (
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                style={{
                  height: "80%",
                }}
              >
                <Grid item>
                  <CircularProgress
                    style={{
                      color: "#ffffff",
                    }}
                  />{" "}
                </Grid>{" "}
              </Grid>
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </AccordionSummary>{" "}
      <AccordionDetails>
        {" "}
        {shopify && loading === false ? (
          <Grid
            container
            direction="row"
            style={{
              minHeight: 250,
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                height: "100%",
              }}
            >
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    height: "15%",
                  }}
                >
                  <Grid
                    container
                    direction="row"
                    style={{
                      height: "100%",
                    }}
                    spacing={1}
                  >
                    <Grid
                      item
                      style={{
                        width: "45%",
                      }}
                    >
                      <Typography variant="body2">
                        <strong> Gateway </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid
                      item
                      style={{
                        width: "30%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          float: "right",
                        }}
                      >
                        <strong> Order Amount </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid
                      item
                      style={{
                        width: "25%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          float: "right",
                        }}
                      >
                        <strong> Total Value </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                  </Grid>{" "}
                </Grid>{" "}
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    style={{
                      height: "100%",
                    }}
                    spacing={1}
                  >
                    {shopify.gateway.map((each, index) => {
                      return (
                        <Grid item xs={12} key={index}>
                          <Grid container direction="row">
                            <Grid
                              item
                              style={{
                                width: "45%",
                              }}
                            >
                              <Typography variant="body2">
                                {" "}
                                {each.gateway}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid
                              item
                              style={{
                                width: "30%",
                              }}
                            >
                              <Typography
                                variant="body2"
                                style={{
                                  float: "right",
                                }}
                              >
                                {each.total_orders}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid
                              item
                              style={{
                                width: "25%",
                              }}
                            >
                              <Typography
                                variant="body2"
                                style={{
                                  float: "right",
                                }}
                              >
                                {each.total_price.toFixed(2)}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            {each.total_partially > 0 ? (
                              <Fragment>
                                <Grid
                                  item
                                  style={{
                                    width: "1%",
                                  }}
                                >
                                  {" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "44%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{
                                      color: "#666666",
                                    }}
                                  >
                                    +Partially Refunded{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "30%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{
                                      float: "right",
                                    }}
                                  >
                                    {each.total_partially}{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "25%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{
                                      float: "right",
                                    }}
                                  >
                                    {each.partially_price.toFixed(2)}{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                              </Fragment>
                            ) : null}{" "}
                            {each.total_refunded > 0 ? (
                              <Fragment>
                                <Grid
                                  item
                                  style={{
                                    width: "1%",
                                  }}
                                >
                                  {" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "44%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{
                                      color: "#666666",
                                    }}
                                  >
                                    +Refunded{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "30%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{
                                      float: "right",
                                      color: "#666666",
                                    }}
                                  >
                                    {each.total_refunded}{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "25%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    style={{
                                      float: "right",
                                      color: "#666666",
                                    }}
                                  >
                                    {each.refunded_price.toFixed(2)}{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                              </Fragment>
                            ) : null}{" "}
                          </Grid>{" "}
                        </Grid>
                      );
                    })}{" "}
                  </Grid>{" "}
                </Grid>{" "}
                <Grid
                  item
                  xs={12}
                  style={{
                    height: "15%",
                  }}
                >
                  <Grid
                    container
                    direction="row"
                    style={{
                      height: "100%",
                    }}
                    spacing={1}
                  >
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid
                      item
                      style={{
                        width: "45%",
                      }}
                    >
                      <Typography variant="body2">
                        <strong> Total </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid
                      item
                      style={{
                        width: "30%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          float: "right",
                        }}
                      >
                        <strong> {shopify.total_orders} </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid
                      item
                      style={{
                        width: "25%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          float: "right",
                        }}
                      >
                        <strong> {shopify.total_price.toFixed(2)} </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>
        ) : (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{
              height: "80%",
            }}
          >
            <Grid item>
              <CircularProgress />
            </Grid>{" "}
          </Grid>
        )}{" "}
      </AccordionDetails>{" "}
    </Accordion>
  );
};

export default Shopify;
